import React, { useState } from "react";
import SuggestedClubs from "../../components/SuggestedClubs";
import LatestNews from "../../components/LatestNews";
import PostList from "../../components/Post";
import CreatePost from "../../components/CreatePost";
import Nav from 'react-bootstrap/Nav';
import { useAuth } from "../../context/AuthContext";


function Home() {
  const [activeTab, setActiveTab] = useState("option1"); // Default tab
  const { isAuthenticated } = useAuth(); // Assuming useAuth provides authentication state
  return (
    <div className="right-panel-inner">
        <div className="post-section">
            <h2 className="mb-20">Home</h2> 
             {/* Navigation Tabs */}
             <Nav variant="pills" activeKey={activeTab} onSelect={(selectedKey) => setActiveTab(selectedKey)}>
              <Nav.Item>
                <Nav.Link eventKey="option1">Private Feed</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="option2">Club Feed</Nav.Link>
              </Nav.Item>
            </Nav>
            {/* Tab Content */}
            <div className="tab-content mt-3">
              {activeTab === "option1" && <div>
                {isAuthenticated && <CreatePost />} {/* Show only if authenticated */}
                <PostList filterByType={["post", "poll"]} />
              </div>}
              {activeTab === "option2" && <div>
                <PostList filterByType="event" />
              </div>}
            </div>
            
            {/* <PostList/> */}
        </div>
        <div className="right-side-bar">
           <SuggestedClubs/>
           <LatestNews/>
        </div>
    </div>
  );
}

export default Home;